package com.dotdrives.web.pages.marketing

import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.ClassName

external interface MarketingLandingProps : Props {
    var onSignIn: () -> Unit
    var onStartTrial: () -> Unit
}

/**
 * The public marketing landing page at the site root ("#/").
 *
 * Pure presentation: it never touches auth, Supabase, or any repository. It takes two
 * navigation callbacks from its caller and renders the page described in
 * design/marketing-landing.dc.html.
 */
val MarketingLandingPage = FC<MarketingLandingProps> { props ->
    MarketingStyles()
    div {
        className = ClassName("marketing-page")
        MarketingNav {
            onSignIn = props.onSignIn
            onStartTrial = props.onStartTrial
        }
        MarketingHero {
            onStartTrial = props.onStartTrial
        }
        MarketingTrustStrip()
        MarketingProcessSection()
        MarketingFeaturesSection()
        MarketingGivingFormsSection()
        MarketingDaySection()
        MarketingRolesSection()
        MarketingStatsAndTestimonials()
        MarketingPricingSection {
            onStartTrial = props.onStartTrial
        }
        MarketingFaqSection()
        MarketingClosingCta {
            onStartTrial = props.onStartTrial
        }
        MarketingFooter()
    }
}
